/* unplugin-vue-components disabled */import { render } from "./templateDemeUpload.vue?vue&type=template&id=08e8d3c0&scoped=true"
import script from "./templateDemeUpload.vue?vue&type=script&lang=js"
export * from "./templateDemeUpload.vue?vue&type=script&lang=js"

import "./templateDemeUpload.vue?vue&type=style&index=0&id=08e8d3c0&scoped=true&lang=css"
import "./templateDemeUpload.vue?vue&type=style&index=1&id=08e8d3c0&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e8d3c0"]])

export default __exports__